(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const disclosure = event.target.closest('.loew-modern-header header-details-disclosure.mega');
    const details = disclosure?.querySelector('details');
    if (!details?.open) return;
    event.preventDefault();
    if (typeof disclosure.close === 'function') {
      disclosure.close();
    } else {
      details.open = false;
    }
    const summary = details.querySelector('summary');
    summary?.setAttribute('aria-expanded', 'false');
    summary?.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loew-deniro-event"] && !Shopify.designMode) return;
  try {
    
  function initDeNiro(section){
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const track=section.querySelector('[data-dn-track]');
    const slides=Array.from(section.querySelectorAll('[data-dn-slide]'));
    const thumbs=Array.from(section.querySelectorAll('[data-dn-thumb]'));
    const previous=section.querySelector('[data-dn-prev]');
    const next=section.querySelector('[data-dn-next]');
    const count=section.querySelector('[data-dn-count]');
    const look=section.querySelector('[data-dn-look]');
    if(!track||!slides.length)return;
    let current=0;
    const update=()=>{current=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));thumbs.forEach((thumb,index)=>thumb.setAttribute('aria-current',String(index===current)));previous.disabled=current===0;next.disabled=current===slides.length-1;count.textContent=count.dataset.countTemplate.replace('__CURRENT__',String(current+1)).replace('__TOTAL__',String(slides.length));};
    const choose=(index,immediate=false)=>{track.scrollTo({left:Math.max(0,Math.min(slides.length-1,index))*track.clientWidth,behavior:immediate||window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
    previous.addEventListener('click',()=>choose(current-1));
    next.addEventListener('click',()=>choose(current+1));
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>choose(index)));
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();choose(current+(event.key==='ArrowRight'?1:-1));}});
    section.querySelectorAll('[data-dn-enquire]').forEach(link=>link.addEventListener('click',()=>{look.value=link.dataset.dnEnquire;}));
    const parameter=new URLSearchParams(window.location.search).get('beispiel');
    const index=slides.findIndex(slide=>slide.dataset.example===parameter);
    if(index>=0){choose(index,true);look.value=slides[index].dataset.title;}
    let width=track.clientWidth;
    new ResizeObserver(()=>{if(track.clientWidth!==width){width=track.clientWidth;choose(current,true);}}).observe(track);
    update();
  }
  document.querySelectorAll('[data-deniro-section]').forEach(initDeNiro);
  document.addEventListener('shopify:section:load',event=>{const section=event.target.querySelector('[data-deniro-section]');if(section)initDeNiro(section);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loew-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loew-editorial-hero')) {
    customElements.define('loew-editorial-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-hero-toggle]');
        if (!this.video || !this.toggle) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userPaused = false;
        this.userRequestedPlay = false;
        this.autoplayBlocked = false;
        this.playPending = false;
        this.video.muted = true;
        this.toggle.hidden = false;

        this.toggle.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.userRequestedPlay = false;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.userRequestedPlay = true;
            this.autoplayBlocked = false;
            this.reconcilePlayback();
          }
        }, { signal });

        this.video.addEventListener('playing', () => {
          if (!this.shouldPlay()) {
            this.video.pause();
            return;
          }
          this.classList.add('has-played');
          this.updateControl();
        }, { signal });
        this.video.addEventListener('pause', () => this.updateControl(), { signal });
        this.video.addEventListener('error', () => {
          this.autoplayBlocked = true;
          this.classList.remove('has-played');
          this.video.pause();
          this.updateControl();
        }, { signal });
        this.motionPreference.addEventListener('change', () => {
          this.userRequestedPlay = false;
          if (this.motionPreference.matches) this.classList.remove('has-played');
          this.reconcilePlayback();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.reconcilePlayback(), { signal });

        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.inView = entries[0].isIntersecting;
          this.reconcilePlayback();
        }, { threshold: 0 });
        this.intersectionObserver.observe(this);
        this.updateControl();
      }

      shouldPlay() {
        return this.isConnected && this.inView && !document.hidden && !this.userPaused &&
          !this.autoplayBlocked && (!this.motionPreference.matches || this.userRequestedPlay);
      }

      reconcilePlayback() {
        if (!this.shouldPlay()) {
          this.video.pause();
          this.updateControl();
          return;
        }
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.shouldPlay()) this.video.pause();
        }).catch((error) => {
          if (error.name !== 'AbortError') this.autoplayBlocked = true;
          this.updateControl();
        }).finally(() => {
          this.playPending = false;
          if (this.shouldPlay() && this.video.paused) this.reconcilePlayback();
        });
      }

      updateControl() {
        const playing = !this.video.paused && !this.video.ended;
        const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.toggle.dataset.state = playing ? 'playing' : 'paused';
        this.toggle.querySelector('[data-hero-toggle-label]').textContent = label;
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.abortController?.abort();
        this.video?.pause();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loew-heritage-countdown"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('heritage-countdown')) {
    customElements.define('heritage-countdown', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.countdownPanel = this.querySelector('[data-countdown-panel]');
        this.heroPanel = this.querySelector('[data-hero-panel]');
        this.clock = this.querySelector('.heritage-countdown__clock');
        this.finished = this.querySelector('.heritage-countdown__finished');
        this.deadline = Date.parse(this.dataset.deadline);
        this.anchorEpoch = Number(this.dataset.renderedAt) * 1000;
        this.anchorMonotonic = performance.now();
        this.clockKnown = this.dataset.renderedAt !== '' && Number.isFinite(this.anchorEpoch) && this.anchorEpoch > 0;
        this.editorPreview = this.dataset.editorPreview === 'true';
        this.launched = this.dataset.launched === 'true';
        this.clockRequest = 0;
        this.nearLaunchSyncSent = false;
        if (!this.countdownPanel || !this.clock || !this.finished || !Number.isFinite(this.deadline)) return;
        this.abortController = new AbortController();
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden && !this.launched) {
            this.tick();
            this.syncClock();
          }
        }, { signal: this.abortController.signal });
        this.tick();
        if (!this.launched) this.syncClock();
      }

      currentTime() {
        if (!this.clockKnown) return null;
        return this.anchorEpoch + Math.max(0, performance.now() - this.anchorMonotonic);
      }

      async syncClock() {
        if (this.syncPending || this.launched || !this.isConnected) return;
        this.syncPending = true;
        const controller = this.abortController;
        const requestController = new AbortController();
        const abortRequest = () => requestController.abort();
        controller.signal.addEventListener('abort', abortRequest, { once: true });
        const requestTimer = window.setTimeout(abortRequest, 8000);
        this.requestTimer = requestTimer;
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.set('_loew_launch_clock', `${Math.floor(performance.now())}-${++this.clockRequest}`);
        try {
          const response = await fetch(url.href, { method: 'HEAD', cache: 'no-store', credentials: 'same-origin', signal: requestController.signal });
          if (!response.ok || requestController.signal.aborted || controller.signal.aborted || !this.isConnected) return;
          const dateValue = response.headers.get('date');
          const serverDate = dateValue ? Date.parse(dateValue) : NaN;
          const ageValue = response.headers.get('age');
          const age = ageValue === null ? 0 : Number(ageValue);
          if (!Number.isFinite(serverDate) || !Number.isFinite(age) || age < 0) return;
          const serverTime = serverDate + age * 1000;
          if (!Number.isFinite(serverTime)) return;
          this.anchorEpoch = Math.max(this.currentTime() || 0, serverTime);
          this.anchorMonotonic = performance.now();
          this.clockKnown = true;
          this.tick();
        } catch (error) {
          if (error.name !== 'AbortError') this.tick();
        } finally {
          window.clearTimeout(requestTimer);
          controller.signal.removeEventListener('abort', abortRequest);
          if (this.abortController === controller) this.syncPending = false;
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.requestTimer);
        this.abortController?.abort();
        this.abortController = null;
        this.syncPending = false;
      }

      tick() {
        window.clearTimeout(this.timer);
        if (!this.isConnected) return;
        const now = this.currentTime();
        if (this.editorPreview || this.launched || now !== null && now >= this.deadline) {
          this.clock.hidden = true;
          if (this.heroPanel) {
            this.countdownPanel.hidden = true;
            this.heroPanel.hidden = false;
            this.dataset.launched = 'true';
            this.launched = true;
          } else {
            this.finished.hidden = false;
          }
          return;
        }
        this.countdownPanel.hidden = false;
        if (this.heroPanel) this.heroPanel.hidden = true;
        this.finished.hidden = true;
        if (now === null) {
          this.clock.hidden = true;
          return;
        }
        const remaining = this.deadline - now;
        const seconds = Math.ceil(remaining / 1000);
        const parts = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        Object.entries(parts).forEach(([name, value]) => {
          const node = this.querySelector(`[data-part="${name}"]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        this.clock.hidden = false;
        this.timer = window.setTimeout(() => this.tick(), Math.min(1000, remaining));
        if (remaining <= 5000 && !this.nearLaunchSyncSent) {
          this.nearLaunchSyncSent = true;
          this.syncClock();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loew-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('loew-journal')) {
    customElements.define('loew-journal', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.loew-journal__track');
        this.controls = this.querySelector('.loew-journal__controls');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.progress = this.querySelector('.loew-journal__progress span');
        if (!this.track || !this.controls) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.controls.addEventListener('click', event => {
          const button = event.target.closest('button[data-direction]');
          if (!button || button.disabled) return;
          const card = this.track.querySelector('.loew-journal__item');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / distance));
          this.track.scrollBy({ left: Number(button.dataset.direction) * distance * visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
        const ratio = this.track.clientWidth / this.track.scrollWidth;
        this.progress.style.width = `${ratio * 100}%`;
        const progress = maximum > 0 ? this.track.scrollLeft / maximum : 0;
        this.progress.style.transform = `translateX(${progress * (1 - ratio) / ratio * 100}%)`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loew-otto-schumacher"] && !Shopify.designMode) return;
  try {
    
function bindOttoAdvice(){
  const contact=document.querySelector('[data-otto-mode="contact"]');
  if(!contact)return;
  const model=contact.querySelector('[data-otto-model-field]');
  const interest=contact.querySelector('[data-otto-interest-field]');
  if(!contact.dataset.ottoPrefilled){
    contact.dataset.ottoPrefilled='true';
    const params=new URLSearchParams(window.location.search);
    const example=(params.get('otto_beispiel')||'').trim().slice(0,160);
    const selected=params.get('otto_interesse');
    if(model&&!model.value)model.value=example||contact.dataset.ottoDefaultModel||'';
    if(interest&&selected&&Array.from(interest.options).some(option=>option.value===selected))interest.value=selected;
  }
  document.querySelectorAll('[data-otto-choice]').forEach(link=>{
    if(link.dataset.ottoBound)return;
    link.dataset.ottoBound='true';
    link.addEventListener('click',()=>{
      if(model){model.value=link.dataset.ottoModel||'';model.dispatchEvent(new Event('input',{bubbles:true}));}
      if(interest&&Array.from(interest.options).some(option=>option.value===link.dataset.ottoInterest))interest.value=link.dataset.ottoInterest;
    });
  });
  const way=contact.querySelector('[data-otto-way]');
  const phone=contact.querySelector('[data-otto-phone]');
  if(way&&phone&&!way.dataset.ottoBound){
    way.dataset.ottoBound='true';
    const update=()=>{phone.required=way.selectedIndex===1;};
    way.addEventListener('change',update);update();
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindOttoAdvice);else bindOttoAdvice();
document.addEventListener('shopify:section:load',bindOttoAdvice);
document.addEventListener('click',event=>{
  const imageButton=event.target.closest('[data-otto-view-image]');
  if(imageButton){
    const image=document.querySelector('.loew-otto__active-image');
    if(image){image.srcset='';image.src=imageButton.dataset.imageUrl;image.alt=imageButton.dataset.imageAlt;const link=image.closest('[data-otto-zoom-open]');if(link){link.href=imageButton.dataset.fullImageUrl;link.dataset.ottoZoomAlt=imageButton.dataset.imageAlt;}}
    return;
  }
  const link=event.target.closest('a[href]');
  if(!link)return;
  let url;
  try{url=new URL(link.href,window.location.href);}catch{return;}
  if(url.origin!==window.location.origin||url.pathname!==window.location.pathname||url.hash!=='#otto-beratung')return;
  const example=(url.searchParams.get('otto_beispiel')||'').trim().slice(0,160);
  if(!example)return;
  const contact=document.querySelector('[data-otto-mode="contact"]');
  if(!contact)return;
  const model=contact.querySelector('[data-otto-model-field]');
  const interest=contact.querySelector('[data-otto-interest-field]');
  const selected=url.searchParams.get('otto_interesse');
  event.preventDefault();
  if(model){model.value=example;model.dispatchEvent(new Event('input',{bubbles:true}));}
  if(interest&&Array.from(interest.options).some(option=>option.value===selected))interest.value=selected;
  const close=document.querySelector('.pswp--open .pswp__button--close');
  if(close)close.click();
  contact.scrollIntoView({behavior:'smooth',block:'start'});
});

function openOttoHash(){
  if(window.location.hash==='#otto-farbideen'){
    const detail=document.getElementById('otto-farbideen');
    if(detail){detail.open=true;detail.scrollIntoView({block:'start'});}
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',openOttoHash);else openOttoHash();
window.addEventListener('hashchange',openOttoHash);


function bindOttoZoom(){
  const dialog=document.querySelector('[data-otto-zoom]');
  if(!dialog||dialog.dataset.ottoZoomBound)return;
  dialog.dataset.ottoZoomBound='true';
  const viewport=dialog.querySelector('[data-otto-zoom-viewport]');
  const image=dialog.querySelector('[data-otto-zoom-image]');
  const caption=dialog.querySelector('[data-otto-zoom-caption]');
  const status=dialog.querySelector('[data-otto-zoom-status]');
  const ratio=dialog.querySelector('[data-otto-zoom-ratio]');
  const out=dialog.querySelector('[data-otto-zoom-out]');
  const into=dialog.querySelector('[data-otto-zoom-in]');
  const originalLink=dialog.querySelector('[data-otto-zoom-original-link]');
  let scale=1,fit=1,ready=false,oldOverflow='',drag=null,lastDistance=0;
  const pointers=new Map();
  function measure(){fit=Math.min(1,(viewport.clientWidth-24)/image.naturalWidth,(viewport.clientHeight-24)/image.naturalHeight);}
  function update(next,x=viewport.clientWidth/2,y=viewport.clientHeight/2){
    if(!ready)return;
    const imageRect=image.getBoundingClientRect(),viewRect=viewport.getBoundingClientRect();
    const ix=(viewRect.left+x-imageRect.left)/scale,iy=(viewRect.top+y-imageRect.top)/scale;
    scale=Math.max(fit,Math.min(1,next));
    image.style.width=Math.round(image.naturalWidth*scale)+'px';
    image.style.height=Math.round(image.naturalHeight*scale)+'px';
    viewport.scrollLeft=image.offsetLeft+ix*scale-x;
    viewport.scrollTop=image.offsetTop+iy*scale-y;
    ratio.textContent=Math.round(scale*100)+' %';
    out.disabled=scale<=fit+.0001;into.disabled=scale>=.9999;
  }
  image.addEventListener('load',()=>{
    if(!dialog.open)return;
    ready=true;measure();scale=fit;
    image.style.width=Math.round(image.naturalWidth*fit)+'px';
    image.style.height=Math.round(image.naturalHeight*fit)+'px';
    viewport.scrollLeft=0;viewport.scrollTop=0;update(fit);
    status.textContent=status.dataset.readyLabel;
  });
  image.addEventListener('error',()=>{if(dialog.open)status.textContent=status.dataset.errorLabel;});
  document.addEventListener('click',event=>{
    const link=event.target.closest('[data-otto-zoom-open]');
    if(!link)return;
    event.preventDefault();
    ready=false;out.disabled=true;into.disabled=true;
    caption.textContent=link.dataset.ottoZoomAlt||'';
    status.textContent=status.dataset.loadingLabel;
    originalLink.href=link.href;
    image.alt=caption.textContent;image.style.width='1px';image.style.height='1px';
    oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
    dialog.showModal();image.src=link.href;
  });
  dialog.querySelector('[data-otto-zoom-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;ready=false;pointers.clear();drag=null;image.removeAttribute('src');});
  out.addEventListener('click',()=>update(scale/1.5));
  into.addEventListener('click',()=>update(scale*1.5));
  dialog.querySelector('[data-otto-zoom-fit]').addEventListener('click',()=>update(fit));
  dialog.querySelector('[data-otto-zoom-original]').addEventListener('click',()=>update(1));
  viewport.addEventListener('wheel',event=>{
    if(!event.ctrlKey&&!event.metaKey)return;
    event.preventDefault();const r=viewport.getBoundingClientRect();
    update(scale*Math.exp(-event.deltaY*.002),event.clientX-r.left,event.clientY-r.top);
  },{passive:false});
  viewport.addEventListener('dblclick',event=>{
    const r=viewport.getBoundingClientRect();update(scale>=.9999?fit:1,event.clientX-r.left,event.clientY-r.top);
  });
  viewport.addEventListener('pointerdown',event=>{
    if(!ready||event.button!==0)return;
    event.preventDefault();viewport.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
    if(pointers.size===1)drag={x:event.clientX,y:event.clientY,left:viewport.scrollLeft,top:viewport.scrollTop};
    if(pointers.size===2){const [a,b]=Array.from(pointers.values());lastDistance=Math.hypot(a.x-b.x,a.y-b.y);}
  });
  viewport.addEventListener('pointermove',event=>{
    if(!pointers.has(event.pointerId))return;
    pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
    if(pointers.size===2){
      const [a,b]=Array.from(pointers.values()),distance=Math.hypot(a.x-b.x,a.y-b.y),r=viewport.getBoundingClientRect();
      if(lastDistance>0)update(scale*distance/lastDistance,(a.x+b.x)/2-r.left,(a.y+b.y)/2-r.top);
      lastDistance=distance;
    }else if(drag){viewport.scrollLeft=drag.left-(event.clientX-drag.x);viewport.scrollTop=drag.top-(event.clientY-drag.y);}
  });
  function release(event){
    pointers.delete(event.pointerId);lastDistance=0;
    if(pointers.size===1){const a=Array.from(pointers.values())[0];drag={x:a.x,y:a.y,left:viewport.scrollLeft,top:viewport.scrollTop};}else drag=null;
  }
  viewport.addEventListener('pointerup',release);viewport.addEventListener('pointercancel',release);
  window.addEventListener('resize',()=>{if(dialog.open&&ready){const oldFit=fit;measure();update(Math.abs(scale-oldFit)<.001?fit:scale);}});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindOttoZoom);else bindOttoZoom();
document.addEventListener('shopify:section:load',bindOttoZoom);

  } catch(e) { console.error(e); }
})();
})();
